import { View } from "@gluestack-ui/themed";

import OtpInput from "react-otp-input";
import { styles } from "./styles";
import { IInputOTPProps } from "./types";

export const Input = ({
  value,
  onChange,
  numInputs,
  inputType,
  placeholder
}: IInputOTPProps) => {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={numInputs}
      inputType={inputType}
      renderSeparator={<View w="$4" />}
      renderInput={(props) => (
        <input
          {...props}
          inputMode="numeric"
          enterKeyHint="done"
          placeholder={inputType === "password" ? "*" : placeholder}
          style={styles.inputStyle}
        />
      )}
    />
  );
};
